var _circle, _circle2, _g, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNoFavorites = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#19222E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    width: 73,
    height: 72,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 36,
    r: 36,
    fill: "#242424"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 24,
    x: -41.5,
    y: 20,
    fill: "#354252",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 61,
    height: 8,
    x: -37.5,
    y: 28,
    fill: "#475566",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFE5EB",
    d: "M35.75 27.46 37 30c.02.04.05.07.09.1l.13.06 2.79.4c.12.01.2.08.22.19.04.11.02.2-.06.29L38.14 33a.35.35 0 0 0-.07.11.31.31 0 0 0-.01.13l.48 2.79a.26.26 0 0 1-.12.28.27.27 0 0 1-.3.01l-2.49-1.3a.23.23 0 0 0-.13-.04c-.05 0-.1.01-.13.04l-2.5 1.3c-.1.06-.2.05-.3-.01a.27.27 0 0 1-.11-.28l.48-2.79c0-.04 0-.08-.02-.13a.25.25 0 0 0-.06-.1l-2.03-1.98a.28.28 0 0 1-.07-.3.27.27 0 0 1 .23-.19l2.8-.4c.04 0 .09-.03.12-.05A.23.23 0 0 0 34 30l1.25-2.54c.05-.1.13-.15.25-.15s.2.05.25.15Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C1CC",
    d: "m45.42 38.04-2.3-.57-1.73 1.43 2.01 4.9-2.59 1.72.87 2.59h3.74l3.16 1.44 5.75-2.88.87-1.15-.87-3.74-2.3-3.45-5.75 1.44-.86-1.73Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D6A7A",
    d: "m41 40.75 1.55 2.68c-.26.09-.5.2-.74.34-1.5.86-1.96 2.58-.94 4.36.82 1.4 2.54.9 3.82.94.52.02 1.03.1 1.5.2h.01c.82.17 1.15.3 1.28.52l.05.09c-.05.26 0 .56.15.83l1.15 2c.32.54.97.76 1.47.47l7.18-4.14c.5-.29.63-.97.32-1.52l-1.15-1.99A1.22 1.22 0 0 0 56 45l-.05-.09c-.51-.9.04-2.8-1.04-4.68l-.38-.66c-1.13-1.95-2.98-2.38-4.64-1.48-.78-.06-1.6.16-2.24.64-.28.01-.56.06-.83.15l-.64-1.11a3.01 3.01 0 0 0-4.09-1.1 3.03 3.03 0 0 0-1.1 4.09Zm3.68-2.13 1.64 2.83a1.62 1.62 0 0 1 1.99-.94c.41-.7 1.39-.87 1.9-.56 1.1-.9 2.1-.8 2.82.47l.38.66c.82 1.42.27 3.05.93 4.46l-5.5 3.17c-.55-.73-1.44-.95-2.3-1.12a9.88 9.88 0 0 0-1.8-.25c-.99-.03-2.22.2-2.37-.08-.42-.72-.52-1.52.3-2 1.1-.63 2.13-.13 2.67-.44l-2.85-4.94a1.3 1.3 0 0 1 .46-1.72c.6-.35 1.4-.13 1.73.46Zm10.12 8.31a.86.86 0 1 1 .86 1.5.86.86 0 0 1-.86-1.5Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNoFavorites);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='73' height='72' fill='none' viewBox='0 0 73 72'%3e%3ccircle cx='36.5' cy='36' r='36' fill='%2319222E'/%3e%3cmask id='a' width='73' height='72' x='0' y='0' maskUnits='userSpaceOnUse' style='mask-type:alpha'%3e%3ccircle cx='36.5' cy='36' r='36' fill='%23242424'/%3e%3c/mask%3e%3cg mask='url(%23a)'%3e%3crect width='90' height='24' x='-41.5' y='20' fill='%23354252' rx='2'/%3e%3crect width='61' height='8' x='-37.5' y='28' fill='%23475566' rx='1'/%3e%3cpath fill='%23DFE5EB' d='M35.75 27.46 37 30c.02.04.05.07.09.1l.13.06 2.79.4c.12.01.2.08.22.19.04.11.02.2-.06.29L38.14 33a.35.35 0 0 0-.07.11.31.31 0 0 0-.01.13l.48 2.79a.26.26 0 0 1-.12.28.27.27 0 0 1-.3.01l-2.49-1.3a.23.23 0 0 0-.13-.04c-.05 0-.1.01-.13.04l-2.5 1.3c-.1.06-.2.05-.3-.01a.27.27 0 0 1-.11-.28l.48-2.79c0-.04 0-.08-.02-.13a.25.25 0 0 0-.06-.1l-2.03-1.98a.28.28 0 0 1-.07-.3.27.27 0 0 1 .23-.19l2.8-.4c.04 0 .09-.03.12-.05A.23.23 0 0 0 34 30l1.25-2.54c.05-.1.13-.15.25-.15s.2.05.25.15Z'/%3e%3c/g%3e%3cpath fill='%23B8C1CC' d='m45.42 38.04-2.3-.57-1.73 1.43 2.01 4.9-2.59 1.72.87 2.59h3.74l3.16 1.44 5.75-2.88.87-1.15-.87-3.74-2.3-3.45-5.75 1.44-.86-1.73Z'/%3e%3cpath fill='%235D6A7A' d='m41 40.75 1.55 2.68c-.26.09-.5.2-.74.34-1.5.86-1.96 2.58-.94 4.36.82 1.4 2.54.9 3.82.94.52.02 1.03.1 1.5.2h.01c.82.17 1.15.3 1.28.52l.05.09c-.05.26 0 .56.15.83l1.15 2c.32.54.97.76 1.47.47l7.18-4.14c.5-.29.63-.97.32-1.52l-1.15-1.99A1.22 1.22 0 0 0 56 45l-.05-.09c-.51-.9.04-2.8-1.04-4.68l-.38-.66c-1.13-1.95-2.98-2.38-4.64-1.48-.78-.06-1.6.16-2.24.64-.28.01-.56.06-.83.15l-.64-1.11a3.01 3.01 0 0 0-4.09-1.1 3.03 3.03 0 0 0-1.1 4.09Zm3.68-2.13 1.64 2.83a1.62 1.62 0 0 1 1.99-.94c.41-.7 1.39-.87 1.9-.56 1.1-.9 2.1-.8 2.82.47l.38.66c.82 1.42.27 3.05.93 4.46l-5.5 3.17c-.55-.73-1.44-.95-2.3-1.12a9.88 9.88 0 0 0-1.8-.25c-.99-.03-2.22.2-2.37-.08-.42-.72-.52-1.52.3-2 1.1-.63 2.13-.13 2.67-.44l-2.85-4.94a1.3 1.3 0 0 1 .46-1.72c.6-.35 1.4-.13 1.73.46Zm10.12 8.31a.86.86 0 1 1 .86 1.5.86.86 0 0 1-.86-1.5Z'/%3e%3c/svg%3e";